import { render, staticRenderFns } from "./registration-success.vue?vue&type=template&id=2c23adaf&scoped=true"
import script from "./registration-success.vue?vue&type=script&lang=js"
export * from "./registration-success.vue?vue&type=script&lang=js"
import style0 from "./registration-success.vue?vue&type=style&index=0&id=2c23adaf&prod&scoped=true&lang=css"
import style1 from "./registration-success.vue?vue&type=style&index=1&id=2c23adaf&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23adaf",
  null
  
)

export default component.exports